import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { configurePdfWorker } from '@examforge/parser';
// Vite-specific: ?url returns a hashed asset URL Vite serves at build/dev time.
import pdfWorkerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';
import { App } from './App.js';
import { LanguageProvider } from './i18n/index.js';
// §O2 (Session 19O): Fraunces variable serif for headings + brand. Self-hosted via
// @fontsource-variable; @import does eager weight 100-900 + opsz 9-144 axis.
import '@fontsource-variable/fraunces';
import './styles/index.css';

// One-time pdf.js worker config — must run before any extract() call.
configurePdfWorker(pdfWorkerUrl);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
    mutations: { retry: 0 }, // Ingest is expensive; no auto-retry — let the user decide.
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root not found in index.html');

createRoot(root).render(
  <StrictMode>
    <LanguageProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </LanguageProvider>
  </StrictMode>,
);
